<template>
  <div>
    <div class="navbar_box_fixed">
      <div class="navbar_box_width">
        <div class="navbar_box_absolute">
          <div class="bar_back_btn" @click="goToJoinedGroups">我的群组</div>
          <div class="page_title on_bar_center_absolute" @click="showActionSheet">{{group.name}}</div>
          <div class="txtbtn_on_bar_right" @click="goToCreateAlbum">新建相册</div>
          <!-- <img class="btn_on_bar_right" src="@/assets/btn_create_album.png" alt="" @click="goToCreateAlbum"> -->
          <!-- <img class="btn_on_bar_right" src="@/assets/btn_show_member.png" alt="" @click="goToGroupSetting"> -->
        </div>
      </div>
    </div>
    <div class="bar_empty_box"></div>

    <div id="theCoverpage" class="coverpage_box_fixed">
      <div class="coverpage_box_width">
        <div class="coverpage_box_ratio">
          <div class="coverpage_box_absolute">
            <img class="coverpage_image" :src="group.coverpageCdnUrl1600" v-if="group.coverpage"  alt="">
            <img class="coverpage_image" src="@/assets/coverpage_group.png" v-if="group.coverpage === ''" alt="">
            <input type="file" ref="coverPageInput" @change="onCoverPageInputChange" style="display:none" />
          </div>
        </div>
      </div>
    </div>
    <div class="coverpage_box_width">
      <div class="coverpage_box_ratio">
        <div class="coverpage_box_absolute" @click="showActionSheet">
          <div class="coverpage_gradient" v-if="group.coverpage">
          </div>
        </div>
      </div>
    </div>

    <div class="box_min_vh100">
      <div class="group_bar">
        <div class="group_bar_avatar">
          <img :src="group.avatarCdnUrl" v-if="group.avatar" alt="">
          <img src="@/assets/avatar.png" v-if="group.avatar === ''" alt="">
          <div class="avatar_empty_border" @click="showActionSheet"></div>
          <input type="file" ref="avatarInput" @change="onAvatarInputChange" style="display:none" />
        </div>
        <div class="group_text" @click="goToEditGroupName">
          <div class="group_name">{{group.name}}</div>
          <div class="group_info">私有群组：{{group.memberCount}}名成员  {{group.photoCount}}张照片</div>
        </div>
        <img class="btn_on_bar_right" src="@/assets/btn_setting.png" alt="" @click="goToGroupSetting">
      </div>

      <div class="bar_empty_box"></div>

      <div class="album_collection">
          <div class="album_box_width" v-for="album in albums" :key="album.id">
            <div class="album_box_padding">
              <div class="album_box_ratio">
                <div class="album_box_absolute" alt="" @click="goToAlbumHome(album.id)">
                  <div class="album_image_ratio">
                    <img class="album_image" :src="album.coverpageCdnUrl" v-if="album.coverpage">
                    <img class="album_image" src="@/assets/coverpage_album_s.png" v-if="album.coverpage === ''">
                  </div>
                  <div class="album_name">{{album.name}}</div>
                  <div class="album_date">{{`${new Date(album.createdAt).getFullYear()}年${new Date(album.createdAt).getMonth() + 1}月${new Date(album.createdAt).getDate()}日`}}</div>
                  <div class="album_count">{{album.photoCount}}</div>
                  <img class="album_icon" src="@/assets/btn_more.png" alt="">
                  <div class="album_empty_border"></div>
                </div>
              </div>
            </div>
          </div>
      </div>
      <div class="clearfix"></div>
      <!-- <div class="footer"> -->
        <!-- <div class="app_bar"> -->
          <!-- <div class="app_icon"></div> -->
          <!-- <div class="app_title">完整功能, 请安装「有朋相册」APP</div> -->
          <!-- <div class="app_subtitle">邀请更多亲朋好友, 共建专属你们的私有相册</div> -->
          <!-- <div class="btn_more"></div> -->
          <!-- <div class="btn_install">免费安装</div> -->
        <!-- </div> -->
      <!-- </div> -->
    </div>
    <mt-actionsheet class="edit_menu"
      :actions="actions"
      v-model="sheetVisible">
    </mt-actionsheet>
  </div>
</template>

<script>
import { initWxShareContent } from '@/lib/wx_jsapi.js';
import util from '@/lib/util.js'
export default {
  name: 'GroupHome',
  data: function () {
    return {
      group: {},
      albums: [],
      currentUserId: '',
      sheetVisible: false,
      actions: [
        { name: '更换群组封面', method: this.updateCoverpage },
        { name: '更换群组头像', method: this.updateAvatar },
        { name: '编辑群组名称', method: this.goToEditGroupName }
      ]
    }
  },
  async created() {
    try {
      this.group = await this.$faApi.getGroupDetail(this.$route.params.groupId)
      this.albums = (await this.$faApi.getGroupAlbums(this.$route.params.groupId)).data
      this.currentUserId = (await this.$faApi.isLogin()).userId

      if (util.isInWeixin()) {
        initWxShareContent(this.group.coverpageCdnUrl, this.group.name)
      }
      
    } catch (err) {
      this.$faLogger.error('GroupHome.vue:created', err)
    }
  },
  mounted() {
    window.onscroll = function() {
      if (window.pageYOffset > 0) {
        document.getElementById('theCoverpage').style.marginTop = -window.pageYOffset / 2 + 'px'
      } else {
        document.getElementById('theCoverpage').style.marginTop = -window.pageYOffset + 'px'
      }
    }
  },
  beforeDestroy() {
    window.onscroll = undefined
  },
  methods: {
    async goToJoinedGroups() {
      const currentUserId = (await this.$faApi.isLogin()).userId
      this.$router.push({ path: `/user/${currentUserId}/joined_groups` })
    },
    showActionSheet() {
      if (this.currentUserId === this.group.ownerId) {
        this.sheetVisible = true
      }
    },
    updateCoverpage() {
      this.$refs.coverPageInput.click()
    },
    async onCoverPageInputChange(e) {
      try {
        const postData = new FormData()
        postData.append('file', e.target.files[0])
        const uploadFileRes = await this.$faApi.uploadFile(postData)
        const updatedGroup = await this.$faApi.updateGroup(this.$route.params.groupId, {
          coverpage: uploadFileRes.filePath
        })
        this.group.coverpage = updatedGroup.coverpage
        this.group.coverpageCdnUrl = updatedGroup.coverpageCdnUrl
      } catch (err) {
        this.$faLogger.error('GroupHome.vue:onCoverPageInputChange', err)
      }
    },
    updateAvatar() {
      if (this.currentUserId === this.group.ownerId) {
        this.$refs.avatarInput.click()
      }
    },
    async onAvatarInputChange(e) {
      try {
        const postData = new FormData()
        postData.append('file', e.target.files[0])
        const uploadFileRes = await this.$faApi.uploadFile(postData)
        const updatedGroup = await this.$faApi.updateGroup(this.$route.params.groupId, {
          avatar: uploadFileRes.filePath
        })
        this.group.avatar = updatedGroup.avatar
        this.group.avatarCdnUrl = updatedGroup.avatarCdnUrl
      } catch (err) {
        this.$faLogger.error('GroupHome.vue:onAvatarInputChange', err)
      }
    },
    goToAddMember() {
      this.$router.push({ path: `/group/${this.$route.params.groupId}/add_member` })
    },
    goToGroupSetting() {
      this.$router.push({ path: `/group/${this.$route.params.groupId}/setting` })
    },
    goToCreateAlbum() {
      this.$router.push({ path: `/group/${this.$route.params.groupId}/create_album` })
    },
    goToAlbumHome(albumId) {
      this.$router.push({ path: `/group/${this.$route.params.groupId}/album/${albumId}` })
    },
    goToEditGroupName() {
      if (this.currentUserId === this.group.ownerId) {
        // 只有群主能编辑群名
        this.$router.push({ path: `/group/${this.$route.params.groupId}/edit_group_name` })
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .navbar_box_fixed {
    z-index: 100;
    position: fixed;
    top: 0;
    width: 100%;
    height: 48px;
    border-bottom: 1px solid #e0e0e0;
    background-color: white;
  }
  .navbar_box_width {
    position: relative;
    width: 100%;
    height: 48px;
  }
  .navbar_box_absolute {
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
  }
  .bar_back_btn {
    position: relative;
    float: left;
    margin: 8px;
    padding: 0 0 0 18px;
    min-width: 32px;
    height: 32px;
    line-height: 32px;
    font-size: 15px;
    font-weight: normal;
    color: red;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: left;
    background-image: url('../assets/btn_back_red.png');
    cursor: pointer;
  }
  .bar_empty_box {
    position: relative;
    width: 100%;
    height: 48px;
  }
  .page_title {
    padding: 0 16px;
    line-height: 48px;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 17px;
    font-weight: 800;
    color: black;
    cursor: pointer;;
    span {
      color: black;
      font-weight: 300;
    }
  }
  .on_bar_center_absolute {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 88px;
    right: 88px;
  }
  .btn_on_bar_right {
    position: relative;
    float: right;
    width: 32px;
    height: 32px;
    margin: 8px 8px 8px 0;
    top: 0;
    right: 0;
    cursor: pointer;
  }
  .coverpage_box_fixed {
    z-index: -100;
    position: fixed;
    width: 100%;
    height: auto;
    background-color: #e0e0e0;
  }
  .coverpage_box_width {
    position: relative;
    float: left;
    width: 100%;
    height: auto;
  }
  .coverpage_box_ratio {
    position: relative;
    width: auto;
    padding-top: 67%;
  }
  .coverpage_box_absolute {
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    cursor: pointer;
  }
  .coverpage_image {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .coverpage_gradient {
    position: absolute;
    width: 100%;
    height: 100%;
    background: -moz-linear-gradient(top, rgba(0,0,0,0) 75%, rgba(0,0,0,0.5) 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top, rgba(0,0,0,0) 75%,rgba(0,0,0,0.5) 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom, rgba(0,0,0,0) 75%,rgba(0,0,0,0.5) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#80000000',GradientType=0 );  /* IE6-9 */
  }
  .group_bar {
    z-index: 99;
    position: relative;
    float: left;
    width: 100%;
    height: 48px;
    border-bottom: 1px solid #e0e0e0;
    background-color: white;
  }
  .group_bar_avatar {
    position: absolute;
    width: 80px;
    height: 80px;
    left: 8px;
    bottom: 8px;
    margin-top: -40px;
    border-radius: 50%;
    overflow: hidden;
    background-color: white;
    img {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .avatar_empty_border {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 1px solid hsla(0,0%,0%,.12);
  }
  .group_text {
    position: absolute;
    left: 96px;
    right: 88px;
    top: 0;
    bottom: 0;
    cursor: pointer;
  }
  .group_name {
    position: absolute;
    left: 0;
    right: 0;
    top: 4px;
    bottom: 20px;
    line-height: 24px;
    font-size: 20px;
    font-weight: bold;
    overflow: hidden;
  }
  .group_info {
    position: absolute;
    left: 0;
    right: 0;
    top: 28px;
    bottom: 4px;
    line-height: 16px;
    font-size: 12px;
    font-weight: normal;
    overflow: hidden;
  }

  .box_min_vh100 {
    position: relative;
    float: left;
    width: 100%;
    height: auto;
    min-height: 100vh;
    background-color: white;
  }

  //相册
  .album_collection {
    position: relative;
    padding: 2px;
  }
  .album_box_width {
    position: relative;
    float: left;
    width: 25%;
  }
  .album_box_padding {
    padding: 2px;
  }
  .album_box_ratio {
    position: relative;
    width: auto;
    padding-top: 100%;
  }
  .album_box_absolute {
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    background-color: white;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
  }
  .album_empty_border {
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    border-radius: 4px;
    border: 1px solid hsla(0,0%,0%,.12);
  }
  .album_image_ratio {
    position: relative;
    width: 100%;
    height: 75%;
  }
  .album_image {
    position: relative;
    width: 100%;
    height: 100%;
    object-fit:cover;
  }
  .album_name {
    position: relative;
    margin: 4px 4px;
    font-size: 16px;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
  }
  .album_date {
    position: absolute;
    bottom: 3px;
    left: 4px;
    font-size: 12px;
    font-weight: normal;
  }
  .album_count {
    position: absolute;
    bottom: 4px;
    right: 20px;
    font-size: 12px;
    font-weight: bold;
    color: red;
  }
  .album_icon {
    position: absolute;
    right: 4px;
    bottom: 6px;
    width: 12px;
    height: 12px;
  }
  .clearfix { clear: both; }
  .footer {
    position: relative;
    width: 100%;
    height: 52px;
    background-color: transparent;
  }
  .app_bar {
    z-index: 1000;
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 48px;
    border-top: 1px solid #e0e0e0;
    background-color: white;
    .app_icon {
      position: absolute;
      margin: 3px;
      left: 0;
      width: 40px;
      height: 40px;
      border-radius: 8px;
      border: 1px solid #e0e0e0;
      background-color: white;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      background-image: url('../assets/logo.png');
    }
    .app_title {
      position: absolute;
      margin: 4px 32px 8px 48px;
      width: auto;
      height: 24px;
      line-height: 24px;
      font-size: 14px;
      font-weight: 800;
      // background-color: gold;
    }
    .app_subtitle {
      position: absolute;
      margin: 24px 32px 8px 48px;
      width: auto;
      height: 16px;
      line-height: 16px;
      font-size: 12px;
      font-weight: 400;
      // background-color: gold;
    }
    .btn_install {
      position: absolute;
      margin: 8px;
      right: 0;
      width: 64px;
      height: 32px;
      line-height: 32px;
      font-size: 12px;
      font-weight: bold;
      border-radius: 4px;
      text-align: center;
      color: white;
      background-color: red;
    }
    .btn_more {
      position: absolute;
      margin: 16px 8px;
      right: 0;
      width: 16px;
      height: 16px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      background-image: url('../assets/btn_more_96x96.gif');
    }
  }
  .edit_menu {
    cursor: pointer;
  }
  @media (max-width: 359px) {
    .album_box_width { width: 50%; }
    .album_name { font-size: 12px;}
  }
  @media (min-width: 360px) and (max-width: 539px) {
    .album_box_width { width: 50%; }
  }
  @media (min-width: 540px) and (max-width: 719px) {
    .album_box_width { width: 33.33%; }
  }
  @media (min-width: 720px) and (max-width: 899px) {
    .album_box_width { width: 25%; }
    .album_collection, .album_box_padding { padding: 4px; }
  }
  @media (min-width: 900px) and (max-width: 1079px) {
    .album_box_width { width: 20%; }
    .album_collection, .album_box_padding { padding: 4px; }
  }
  @media (min-width: 1080px) and (max-width: 1259px) {
    .album_box_width { width: 16.66%; }
    .album_collection, .album_box_padding { padding: 4px; }
  }
  @media (min-width: 1260px) and (max-width: 1679px) {
    .album_box_width { width: 16.66%; }
    .album_collection, .album_box_padding { padding: 4px; }
  }
  @media (min-width: 1680px) and (max-width: 1919px) {
    .album_box_width { width: 12.5%; }
    .album_collection, .album_box_padding { padding: 4px; }
  }
  @media (min-width: 1920px) {
    .album_box_width { width: 10%; }
    .album_collection, .album_box_padding { padding: 4px; }
  }

</style>
